import { css } from '@linaria/core';
import { breakpoints } from 'styles/utils';
export const pinkText = "odules__Home__components__Plan_styles_ts-pinkText-p116z2q9";
export const progressBarWrapper = "odules__Home__components__Plan_styles_ts-progressBarWrapper-pf89zuv";
export const progressBar = "odules__Home__components__Plan_styles_ts-progressBar-pnr4wt5";
export const planCardWrapper = "odules__Home__components__Plan_styles_ts-planCardWrapper-plmdp79";
export const planCardBody = "odules__Home__components__Plan_styles_ts-planCardBody-p1t9iqyk";

require("./Plan.styles.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Plan.styles.ts");